import { render } from "./fighthistory.vue?vue&type=template&id=c4a9f692"
import script from "./fighthistory.vue?vue&type=script&lang=js"
export * from "./fighthistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__